export default function CollabXIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden
      className="eunpyeongcare-page__collab-x"
    >
      <path
        d="M14.0625 3.9375L3.9375 14.0625"
        stroke="#28C8A8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0625 14.0625L3.9375 3.9375"
        stroke="#28C8A8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
